import { Injectable } from '@angular/core';
import { Note } from '@models/notes/note';
import { NoteRecord } from "@models/notes/note-record";
import { PageResult } from '@models/requests/page-result.interface';
import { FileCreateDto } from '@models/ui-models/files';
import BaseApiService from "@shared/services/base/base-api.service";
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotesApiService extends BaseApiService {
  getNotes(entityIdOrIndividualId: string, startRow = 0, endRow = 10): Observable<PageResult<Note>> {
    const options = { params: { startRow, endRow } };

    return this.api.get<PageResult<Note>>(`${ this.apiUrl }/notes/${ entityIdOrIndividualId }/list`, options)
      .pipe(map((response) => {
        response.records = response.records.map((note) => new Note(note));
        return response;
      }));
  }

  getNotesTotal(entityId: string): Observable<number> {
    return this.getNotes(entityId, 0, 0)
      .pipe(map(response => response.total ?? 0));
  }

  createEditNote(note: NoteRecord): Observable<Note> {
    return this.api.post<Note>(`${ this.apiUrl }/notes`, note);
  }

  downloadNoteFile(noteId: string, filename: string): Observable<string> {
    const options = { params: { filename } };
    return this.api.get<string>(`${ this.apiUrl }/notes/${ noteId }/download`, options);
  }

  deleteNoteFile(noteId: string, filename: string): Observable<void> {
    const options = { params: { filename } };
    return this.api.delete<void>(`${ this.apiUrl }/notes/${ noteId }/attachment`, options);
  }

  uploadNoteFile(noteId: string, file: FileCreateDto): Observable<void> {
    return this.api.post<void>(`${ this.apiUrl }/notes/${ noteId }/attachment`, file);
  }

  deleteNote(noteId: string): Observable<void> {
    return this.api.delete<void>(`${ this.apiUrl }/notes/${ noteId }`);
  }
}
